import React, { useRef, useEffect, useState, useCallback } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss';
import '../layout/sass/_responsiveTable.scss';
import api from '../api/api';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';

export const TabelaFilaInstrumentos = () => {
    const toast = useRef(null);
    const [cursoTeoria, setCursoTeoria] = useState(null);
    const [cursosTeoria, setCursosTeoria] = useState([]);
    const [curso, setCurso] = useState(null); // instrumento
    const [cursos, setCursos] = useState([]);
    const [filaInstrumentos, setFilaInstrumentos] = useState([]);
    const [ano, setAno] = useState(new Date().getFullYear());
    const [perfil, setPerfil] = useState(null);
    const [showPerfil, setShowPerfil] = useState(false);
    const [loading, setLoading] = useState(false);

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">Fila Instrumentos</h2>
                <h2 className="p-my-0">Total: {filaInstrumentos.length}</h2>
            </div>
        </div>
    );

    // Templates de coluna
    const instrumentoBodyTemplate = (rowData) => (
        <p className="table-data" style={{ textAlign: 'left', margin: 0 }}>
            {rowData.instrumentoNome}
        </p>
    );

    const alunoBodyTemplate = (rowData) => (
        <p className="table-data" style={{ textAlign: 'left', margin: 0 }}>
            {rowData.alunoNome}
        </p>
    );

    const cursoBodyTemplate = (rowData) => (
        <p className="table-data" style={{ textAlign: 'left', margin: 0 }}>
            {rowData.cursoNome}
        </p>
    );

    const turmaBodyTemplate = (rowData) => (
        <p className="table-data" style={{ textAlign: 'left', margin: 0 }}>
            {rowData.cursoNome} - {rowData.diaSemana} - {rowData.hora}
        </p>
    );

    const perfilBodyTemplate = (rowData) => (
        <Button
            icon="pi pi-info"
            className="p-button-rounded p-button-secondary"
            onClick={() => handlePerfilClick(rowData.perfil)}
            style={{ height: '28px', width: '28px' }}
        />
    );

    // Carrega listas fixas
    const getCursos = useCallback(async () => {
        try {
            const response = await api.get(`curso/instrumento`);
            setCursos(response.data);
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro ao carregar instrumentos'
            });
        }
    }, []);

    const getCursosTeoria = useCallback(async () => {
        try {
            const response = await api.get(`curso/teoria`);
            setCursosTeoria(response.data);
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro ao carregar cursos teóricos'
            });
        }
    }, []);

    // Busca padrão (sem filtros)
    const getFilaPadrao = async () => {
        setLoading(true);
        try {
            const response = await api.get(`matricula/filaInstrumento/${ano}`);
            setFilaInstrumentos(response.data);
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro ao carregar fila padrão'
            });
        } finally {
            setLoading(false);
        }
    };

    // Busca com filtros
    const buscarFilaComFiltros = async () => {
        setLoading(true);
        const pesquisa = {
            cursoId: cursoTeoria || null,
            instrumentoId: curso || null,
            ano: ano || new Date().getFullYear()
        };

        try {
            const response = await api.post(`matricula/filaInstrumento`, pesquisa);
            setFilaInstrumentos(response.data);
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Erro ao filtrar fila de instrumentos'
            });
        } finally {
            setLoading(false);
        }
    };

    // useEffect: Carrega dados iniciais
    useEffect(() => {
        const carregarDadosIniciais = async () => {
            await Promise.all([getCursos(), getCursosTeoria()]);
            await getFilaPadrao();
        };
        carregarDadosIniciais();
    }, [getCursos, getCursosTeoria]);

    // useEffect: Reage aos filtros
    useEffect(() => {
        // Se todos os filtros estiverem vazios → busca padrão
        if (curso === null && cursoTeoria === null && ano === new Date().getFullYear()) {
            getFilaPadrao();
        } else {
            buscarFilaComFiltros();
        }
    }, [curso, cursoTeoria, ano]);

    const handlePerfilClick = (perfilData) => {
        setPerfil(perfilData);
        setShowPerfil(true);
    };

    const formatCpf = (cpf) => {
        if (!cpf) return '';
        return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    };

    return (
        <>
            <Toast ref={toast} position="bottom-right" />

            {/* Dialog Perfil */}
            <Dialog
                header="Perfil do Aluno"
                visible={showPerfil}
                onHide={() => setShowPerfil(false)}
                breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                style={{ width: '50vw' }}
                className="p-dialog-scroll"
            >
                {perfil && (
                    <div className="p-grid p-fluid">
                        <div className="p-col-12"><strong>Nome:</strong> {perfil.nome}</div>
                        <div className="p-col-12"><strong>CPF:</strong> {formatCpf(perfil.cpf)}</div>
                        <div className="p-col-12"><strong>Email:</strong> {perfil.email}</div>
                        <div className="p-col-12"><strong>Data de Nascimento:</strong> {new Date(perfil.dataNascimento).toLocaleDateString()}</div>
                        <div className="p-col-12"><strong>Deficiência:</strong> {perfil.deficiencia || 'Não'}</div>
                        <div className="p-col-12"><strong>Responsável:</strong> {perfil.responsavel || '—'}</div>
                        <div className="p-col-12"><strong>Telefone:</strong> {perfil.telefone || '—'}</div>
                        <div className="p-col-12"><strong>Celular:</strong> {perfil.celular || '—'}</div>
                    </div>
                )}
            </Dialog>

            {/* Tabela */}
            <div className="card p-col-12 datatable-responsive-demo">
                <DataTable
                    value={filaInstrumentos}
                    header={header}
                    loading={loading}
                    className="p-datatable-responsive-demo"
                    emptyMessage="Nenhum aluno na fila"
                    dataKey="id"
                    rows={50}
                    filterDisplay="row"
                >
                    <Column
                        field="instrumentoNome"
                        header="Instrumento"
                        body={instrumentoBodyTemplate}
                        filter
                        filterElement={
                            <Dropdown
                                value={curso}
                                options={cursos}
                                optionLabel="nome"
                                optionValue="id"
                                placeholder="Todos os instrumentos"
                                showClear
                                filter
                                style={{ width: '100%', marginTop: '8px' }}
                                onChange={(e) => setCurso(e.value)}
                            />
                        }
                    />

                    <Column
                        field="alunoNome"
                        header="Aluno"
                        body={alunoBodyTemplate}
                    />

                    <Column
                        field="cursoNome"
                        header="Curso"
                        body={cursoBodyTemplate}
                        filter
                        filterElement={
                            <Dropdown
                                value={cursoTeoria}
                                options={cursosTeoria}
                                optionLabel="nome"
                                optionValue="id"
                                placeholder="Todos os cursos"
                                showClear
                                filter
                                style={{ width: '100%', marginTop: '8px' }}
                                onChange={(e) => setCursoTeoria(e.value)}
                            />
                        }
                    />

                    <Column
                        field="turma"
                        header="Turma"
                        body={turmaBodyTemplate}
                    />

                    <Column
                        field="perfil"
                        header="Perfil"
                        body={perfilBodyTemplate}
                        style={{ width: '150px', textAlign: 'center' }}
                        filter
                        filterElement={
                            (() => {
                                const currentYear = new Date().getFullYear();
                                const minYear = currentYear - 5;
                                const maxYear = currentYear + 2;

                                return (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '100%',
                                        }}
                                    >
                                        <input
                                            type="number"
                                            value={ano ?? ''}
                                            onChange={(e) => setAno(Number(e.target.value))}
                                            min={minYear}
                                            max={maxYear}
                                            style={{
                                                width: '84px', // 20% maior que 70px
                                                textAlign: 'center',
                                                fontSize: '1.02rem', // 20% maior que 0.85rem
                                                padding: '0.3rem', // levemente aumentado
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                outline: 'none',
                                            }}
                                        />
                                    </div>
                                );
                            })()
                        }
                    />





                </DataTable>
            </div>
        </>
    );
};

